import {isEmpty} from 'lodash/lang';
import * as types from '../actions/types';

const initialState = {
    isAuthenticated: false,
    user: {},
};

const setCurrentUserReducer = (state, action) => {
    if (isEmpty(action.user)) {
        return initialState;
    }
    let user = action.user || {};
    return {
        isAuthenticated: !isEmpty(localStorage.getItem('cwbJwt')),
        user: user,
    };
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case types.SET_CURRENT_ACCOUNT:
            return setCurrentUserReducer(state, action);
        default:
            return state;
    }
};
